import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import styles from "./StaffClientsModal.module.scss";
import close from "Assets/images/cross_icon.png";
import { useLazyGetFileUrlQuery } from "store/services/utility";
import DocViewModal from "components/Common/DocViewModal";
import { useGetPoliciesDataQuery } from "store/services/V2/profile";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { useAcceptTermsMutation } from "store/services/auth";

const validationSchema = Yup.object({
    isHealthProfessional: Yup.boolean().oneOf([true], "Required"),
    agrees30Days: Yup.boolean().oneOf([true], "Required"),
    agreesPrivacy: Yup.boolean().oneOf([true], "Required"),
});


const initialValues = {
    isHealthProfessional: false,
    agrees30Days: false,
    agreesPrivacy: false,
};


const TermsAndConditionsPop = ({ show, setShow }) => {
    const handlePopup = () => setShow(false);

    const [acceptTerms, { isLoading: acceptTermsLoading }] = useAcceptTermsMutation();

    const handleSubmit = async (values) => {
        const data = {
            termsAndConditionsStatus: "accepted"
        }
        try {
            await acceptTerms({ data }).unwrap();
            handlePopup();
        } catch (error) {
            console.log('error', error)
        }
    };

    // const { data: policy, isLoading: policyLoading } = useGetPoliciesDataQuery();
    const policy = ['terms_and_conditions_trackabilities_1779915311721.pdf', 'privacy_policy_trackabilities_1779915161584.pdf']


    const [showDocModal, setShowDocModal] = useState(false);
    const [selectedPolicy, setSelectedPolicy] = useState(null);
    const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();

    const handleOpenPolicy = async (policy, e) => {
        e.preventDefault();
        console.log('policy', policy)

        const result = await getFileUrl(policy);
        if (result?.error) return;

        const url = result?.data
        let policyData = {
            ...policy,
            url
        }

        if (url) {
            setSelectedPolicy(policyData);
            setShowDocModal(true);
        }

    };

    const checkboxItems = [
        {
            name: "isHealthProfessional",
            label:
                "I agree that I am a regulated health care professional or a certified teacher and I adhere to regulatory requirements of my professional association with regards to storing and transferring student reports.",
        },
        {
            name: "agrees30Days",
            label:
                "I agree that the Trackabilities dashboard will only store client reports for 30 days, and if I need access to a client report after 30 days I must contact the clinician directly.",
        },
        {
            name: "agreesPrivacy",
            // label:
            //     `I agree to the terms of use and privacy policy when using the Trackabilities dashboard.`,
            label: (
                <>
                    I agree to the <span
                        onClick={(e) => { handleOpenPolicy(policy?.[0], e) }}
                        className="step-policy-review text-purple"
                        style={{ cursor: "pointer" }}
                    >
                        terms of use
                    </span>{" "} and{" "}
                    <span
                        onClick={(e) => handleOpenPolicy(policy?.[1], e)}
                        className="step-policy-review text-purple"
                        style={{ cursor: "pointer" }}
                    >
                        privacy policy
                    </span>{" "}
                    when using the Trackabilities dashboard.
                </>
            ),
        },
    ];

    return (
        <Modal
            show={show}
            className={`${styles.AddNewGoalPop} modal-v2 AddNewGoalPop`}
            onHide={handlePopup}
            backdrop="static"
            keyboard={false}
            centered
            size="md"
        >
            {(getFileFetching || acceptTermsLoading) && <LoadingOverlay />}
            <Modal.Body
                className={`${styles.modalBody} position-relative rounded`}
                style={{ padding: "28px 32px 32px" }}
            >
                {/* Close Button */}
                {/* <div className="d-flex justify-content-end mb-2">
                    <img
                        onClick={handlePopup}
                        width={16}
                        height={16}
                        src={close}
                        alt="close"
                        style={{ cursor: "pointer" }}
                    />
                </div> */}

                {/* Title */}
                <div
                    className="mb-3 pb-2"
                    style={{ borderBottom: "1px solid #315D99" }}
                >
                    <h6
                        className="mb-0 fw-bold"
                        style={{ color: "#315D99", fontSize: "14px", letterSpacing: "0.5px" }}
                    >
                        AGREEMENT
                    </h6>
                </div>

                {/* Description */}
                <p style={{ fontSize: "14px", color: "#333", lineHeight: "1.6", marginBottom: "16px" }}>
                    Trackabilities is a temporary storage for student reports completed by
                    the clinicians who work for Khan Communication Services. Reports are
                    stored on a cloud based HIPAA compliant dashboard for 30 days, and the
                    dashboard only allows authenticated users to access the reports, and
                    transfer them to their own school based storage systems. Trackabilites
                    also allows users to view tasks that are assigned to educational
                    assistants by the clinicians.
                </p>

                <p style={{ fontSize: "14px", color: "#333", lineHeight: "1.6", marginBottom: "20px" }}>
                    Users must have knowledge and understanding of provincial and federal
                    regulations on protection, privacy and secure handling of student
                    reports and therefore must be a regulated health care professional or a
                    certified teacher.
                </p>

                {/* Formik Form */}
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ values, isValid, dirty }) => (
                        <>
                            <DocViewModal
                                show={showDocModal}
                                setShow={setShowDocModal}
                                doc={selectedPolicy}
                                // onAccept={handleAcceptPolicy}
                                values={values}
                            />
                            <Form>
                                <div className="d-flex flex-column gap-3 mb-4">
                                    {checkboxItems.map(({ name, label }) => (
                                        <label
                                            key={name}
                                            className="d-flex align-items-start gap-3"
                                        // style={{ cursor: "pointer" }}
                                        >
                                            <Field name={name}>
                                                {({ field }) => (
                                                    <input
                                                        type="checkbox"
                                                        {...field}
                                                        checked={field.value}
                                                        style={{
                                                            width: "18px",
                                                            height: "18px",
                                                            minWidth: "18px",
                                                            marginTop: "2px",
                                                            accentColor: "#315D99",
                                                            cursor: "pointer",
                                                        }}
                                                    />
                                                )}
                                            </Field>
                                            <span style={{ fontSize: "14px", color: "#333", lineHeight: "1.6" }}>
                                                {label}
                                            </span>
                                        </label>
                                    ))}
                                </div>

                                {/* Continue Button */}
                                <div className="d-flex justify-content-center">
                                    <button
                                        type="submit"
                                        disabled={!(isValid && dirty) || !Object.values(values).every(Boolean)}
                                        style={{
                                            backgroundColor:
                                                Object.values(values).every(Boolean) ? "#315D99" : "#aaa",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "6px",
                                            padding: "10px 48px",
                                            fontSize: "15px",
                                            fontWeight: "500",
                                            cursor: Object.values(values).every(Boolean)
                                                ? "pointer"
                                                : "not-allowed",
                                            transition: "background-color 0.2s ease",
                                            minWidth: "160px",
                                        }}
                                    >
                                        Continue
                                    </button>
                                </div>
                            </Form>
                        </>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default TermsAndConditionsPop;